import store from '../store';
import { appid } from './env';
import WechatApi from 'api/WechatApi';

const mobileLogin = async(referId) => {
  if (process.env.NODE_ENV === 'production') {
    const data = {};
    if (referId) {
      data.source = +referId;
    }
    const code = getQueryString('code');
    const key = getAllQuertString('key') || getAllQuertString('token');
    console.log('key >>>>', key);
    if (key) {
      await store.dispatch('creatKey', key);
    } else if (code) {
      data.code = code;
      await WechatApi.getUserKey(data).then(async res => {
        if (res.code === 20000) {
          await store.dispatch('creatKey', res.data.key);
        }
      });
    } else {
      weChatLogin();
    }
  } else { // 本地测试
    await store.dispatch('creatKey', '497ed937f0da8bcc53147712aa3f791e688c4dc914eb62a85bc57107e264dac7');
  }
};

// 微信授权登陆跳转
function weChatLogin() {
  const redirectUrl = encodeURIComponent(window.location.origin + window.location.pathname + window.location.hash);
  const scope = 'snsapi_userinfo';
  window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + appid + '&redirect_uri=' + redirectUrl + '&response_type=code&scope=' +
    scope + '&state=STATE#wechat_redirect';
}

function clearCookie(name) {
  setCookie(name, '', -1);
}

// 获取url中的code参数
function getQueryString(name) {
  const reg = '(^|&)' + name + '=([^&]*)(&|$)';
  const r = window.location.search.substr(1).match(reg);
  if (r != null) return unescape(r[2]);
  return null;
}

/**
 *  为了获取URL上的值
 * @param {*} name 需要获取的key
 * @param {*} isMerge 是否合并hash和search,search优先级高
 */
export const getAllQuertString = (name, isMerge = true) => {
  const reg = '(?:^|&)' + name + '=([^&]*)(?:&|$)';
  const regObj = new RegExp(reg, 'i');
  const search = window.location.search.substr(1);
  const hash = window.location.hash.split('?')[1];
  const searchR = search ? search.match(regObj) && search.match(regObj)[1] : null;
  const hashR = hash ? hash.match(regObj) && hash.match(regObj)[1] : null;
  if (isMerge) {
    const result = searchR || hashR;
    return result ? unescape(result) : null;
  } else {
    return {
      search: searchR ? unescape(searchR) : null,
      hash: hashR ? unescape(hashR) : null
    };
  }
};

const getCookie = function(cname) {
  var name = cname + '=';
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i].trim();
    if (c.indexOf(name) === 0) return c.substring(name.length, c.length);
  }
  return '';
};
// 设置cookie,增加到vue实例方便全局调用
const setCookie = function(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  const expires = 'expires=' + d.toGMTString();
  document.cookie = cname + '=' + cvalue + '; ' + expires;
};
export { mobileLogin, getCookie, setCookie, clearCookie, weChatLogin };
